import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import paywallBg from "../../assets/imgs/paywall-bg.png";
import { Layout } from "../Layouts/Layout";
import { useSupabaseAuth } from "../../Context/AuthContext/AuthContext";
import { usePaywallStore } from "../../zustandStore/paywallStore";
import {
  MONTLY_SUBSCRIPTION,
  YEARLY_SUBSCRIPTION,
  PRESEASON_SUBSCRIPTION,
} from "../Subscription/PaymentMethod/constant";
import rotobotAi from "../../assets/imgs/robot_small.svg";
import { isMobile } from "react-device-detect";
import useFirebaseAnalytics from "../../hooks/useFirabaseAnality";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";
import { useRevenueCatAuth } from "../../Context/RevenueCatContext/RevenueCatContext";
import ChatbotImg from "../../assets/imgs/ai-chat-logo.svg";
import subscribeRight from "../../assets/imgs/subscribe_right.svg";
import AutoScroll from "./AutoScroll";
import BackButton from "../Commons/BackButton/BackButton";
import { hapticsImpactLight } from "../../lib/utils";
import ArrowBackIcon from "../../assets/imgs/arrow-back-left.svg";
import closeIcon from "../../assets/imgs/close.svg";
import draftHelp from "../../assets/imgs/draft-help-p.svg";
import leagueSync from "../../assets/imgs/league-sync-p.svg";
import tradeAnalyzer from "../../assets/imgs/trade-analyzer-p.svg";
import advancedStats from "../../assets/imgs/advanceds-statistics-p.svg";
import unlimitedChats from "../../assets/imgs/unlimited-chats-p.svg";

import sitStartAnalyzer from "../../assets/imgs/sit-start-analyzer-p.svg";
import plusEvBets from "../../assets/imgs/ev-bets-p.svg";
import forYouPage from "../../assets/imgs/for-you-page-p.svg";
import leagueHub from "../../assets/imgs/league-hub-p.svg";

const EarlyBirdPaywall = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPaywallSeen = location.state?.HasPaywallSeen || false;
  // const { subscriptions, purchaseProduct, platform } = useApplePaymentAuth();
  const {
    products: subscriptions,
    platform,
    purchaseProduct,
  } = useRevenueCatAuth();
  const { getUserProfile, getUserData, useAuthStore } = useSupabaseAuth();
  const { setHasSeenPaywall } = usePaywallStore();
  const [currentUser, setCurrentUser] = React.useState<any>(null);
  const [isInitilized, setIsInitilized] = React.useState(false);
  const [userProfile, setUserProfile] = React.useState<any>(null);
  const [priceMontly, setPriceMontly] = React.useState("$6.99");
  const [priceYearly, setPriceYearly] = React.useState("$49.99");
  const [pricePreSeason, setPricePreSeason] = React.useState("$59.99");
  const { logEventAnalytics } = useFirebaseAnalytics();
  const Mixpanel = useMixpanel();
  // Add state for animation
  const [isVisible, setIsVisible] = React.useState(false);
  const [showButton, setShowButton] = React.useState(false);
  const [showTrialButton, setShowTrialButton] = React.useState(false);
  const profile = useAuthStore((state: any) => state.profile);

  // Add visibility condition variable
  const shouldShowButtons =
    profile?.is_super_user ||
    (!profile?.is_super_user && !profile?.hard_paywall);

  // Combined condition for button visibility
  const shouldShowBackButton = shouldShowButtons && showButton;

  const featuresRow = [
    "Unlimited Chatbot Inputs",
    "Curated Content Feed",
    "Sit/Start Tool",
    "Advanced Stat Pulling",
    "Access to player splits",
    "Fantasy League Sync",
    "Find EV+ Bets",
    "Player splits tool",
    "Draft Tool",
    "Fantasy Recommendations",
    "Best Ball Draft Help",
    "Dynasty League Analysis",
    "Trade Analysis Tool",
    "Access Any Advanced Player Metric",
    "Daily Trivia",
  ];

  useEffect(() => {
    // Trigger animation after component mount
    setTimeout(() => {
      setIsVisible(true);
    }, 100); // Small delay for better effect

    // Show button and close button with 1 second delay
    setTimeout(() => {
      setShowButton(true);
    }, 1000);

    // Show trial button with 500ms delay (0.5 seconds)
    setTimeout(() => {
      setShowTrialButton(true);
    }, 300);
  }, []);

  useEffect(() => {
    const fethProfile = async () => {
      if (currentUser?.id) {
        const responde = await getUserProfile(currentUser?.id);
        console.log(responde?.hard_paywall, "responde");
        setUserProfile(responde);

        // Conditional event tracking based on hard_paywall status
        if (responde?.hard_paywall) {
          Mixpanel.trackEvent("hard_paywall_viewed", {
            name: "Hard Paywall Viewed",
          });
        } else {
          Mixpanel.trackEvent("soft_paywall_viewed", {
            name: "Soft Paywall Viewed",
          });
        }
      }
    };

    if (currentUser?.id) {
      fethProfile();
    }
  }, [currentUser?.id]);

  const fetchCurrentUser = async () => {
    const response = await getUserData();

    if (response) {
      setCurrentUser(response?.data?.user);
    }
  };

  const fetchPrice = async () => {
    if (isMobile && platform && platform === "ios") {
      const itemPreSeason = subscriptions.find(
        (sub) => sub.product.identifier === PRESEASON_SUBSCRIPTION,
      );
      console.log(itemPreSeason, "itemPreSeason");
      if (itemPreSeason) {
        setPricePreSeason(itemPreSeason.product?.priceString);
      }

      const itemMonthly = subscriptions?.find(
        (sub) => sub.product.identifier === MONTLY_SUBSCRIPTION,
      );
      console.log(itemMonthly, "itemMonthly 86");
      if (itemMonthly) {
        setPriceMontly(itemMonthly.product?.priceString);
      }

      const itemYearly = subscriptions.find(
        (sub) => sub.product.identifier === YEARLY_SUBSCRIPTION,
      );
      console.log(itemYearly, "itemYearly 92");
      if (itemYearly) {
        setPriceYearly(itemYearly.product?.priceString);
      }
    }
  };

  useEffect(() => {
    if (!isInitilized) {
      fetchCurrentUser();
      setIsInitilized(true);
    }
  }, [isInitilized]);

  useEffect(() => {
    fetchPrice();
  }, [subscriptions]);

  const handleSubscribeClick = async () => {
    Mixpanel.trackEvent("subscription_initiated", {
      plan_type: "preseason",
      plan_price: pricePreSeason,
    });
    purchaseProduct(userProfile, currentUser?.id, PRESEASON_SUBSCRIPTION);
  };

  const closePaywall = () => {
    hapticsImpactLight();
    setHasSeenPaywall(true);
    setIsVisible(false);
    setShowButton(false);
    setShowTrialButton(false);
    // Delay navigation to allow animation to complete
    setTimeout(() => {
      navigate("/chatbot-ai", {
        state: {
          showAnimation: true, // Pass the showAnimation state to the next screen
        },
      });
    }, 400); // 500ms matches the duration in the wrapper div's transition
  };

  const handleClick = () => {
    hapticsImpactLight();
    // Trigger exit animation
    setIsVisible(false);
    setShowButton(false);
    setShowTrialButton(false);
    // Delay navigation to allow animation to complete
    setTimeout(() => {
      navigate(-1);
    }, 400); // 500ms matches the duration in the wrapper div's transition
  };

  const getNowFeatures = [
    {
      title: "Sync Your League",
      description: "Personalized insights for your specific teams",
      icon: leagueSync,
    },
    {
      title: "Unlimited Chats",
      description: "Personalized insights for your specific teams",
      icon: unlimitedChats,
    },
    {
      title: "Draft Help",
      description: "Expert recommendations on which players to draft",
      icon: draftHelp,
    },
    {
      title: "Trade Analyzer",
      description: "In-depth, statistically backed analysis tailored for you",
      icon: tradeAnalyzer,
    },
    {
      title: "Advanced Statistics",
      description: "Access to advanced stats and splits for every player",
      icon: advancedStats,
    },
  ];

  const comingFeatures = [
    {
      title: "League Hub",
      description: "Dashboard of trade, sit/start and waiver advice for you",
      icon: leagueHub,
    },
    {
      title: "+EV Bets",
      description: "Analysis to help you find edges on player props",
      icon: plusEvBets,
    },
    {
      title: "Sit/Start Analyzer",
      description: "In-depth analysis for all your weekly sit/start decisions",
      icon: sitStartAnalyzer,
    },
    {
      title: "For You Page",
      description: "Custom-made player news & insights",
      icon: forYouPage,
    },
  ];

  return (
    <div className="no-select">
      <div
        className={`w-full h-full transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >
        <Layout isPaywall={true}>
          {/* Background Image */}
          <div
            className="relative w-full min-h-[51vh] items-center gap-3 flex-1 px-5"
            style={{
              backgroundImage: `url(${paywallBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              paddingTop: "calc(env(safe-area-inset-top) + 16px)",
            }}
          >
            <div>
              <div className="flex flex-col items-center w-full space-y-1">
                <div>
                  {shouldShowBackButton && (
                    <motion.div
                      className={`cursor-pointer rounded-[100px] w-[40px] h-[40px] flex justify-center items-center grayBtn absolute left-5 backdrop-blur-sm `}
                      style={{
                        top: "calc(env(safe-area-inset-top) + 16px)",
                      }}
                      onClick={hasPaywallSeen ? closePaywall : handleClick}
                      initial={{ opacity: 0, scale: 0.8, x: -20 }}
                      animate={{ opacity: 1, scale: 1, x: 0 }}
                      transition={{
                        duration: 0.1,
                        ease: "easeOut",
                        type: "spring",
                        stiffness: 200,
                      }}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      {hasPaywallSeen ? (
                        <img
                          src={closeIcon}
                          alt="close"
                          className="w-[12.4px] h-[12.4px]"
                        />
                      ) : (
                        <img
                          src={ArrowBackIcon}
                          alt="Back"
                          className={"h-[12px]"}
                        />
                      )}
                    </motion.div>
                  )}

                  <img
                    src={ChatbotImg}
                    alt="ChatbotImg"
                    className="w-[26.73px] h-[20.54px] mx-auto"
                  />
                </div>

                <div className="flex items-center justify-center gap-1">
                  <div>
                    <img src={rotobotAi} alt="rotobotAi" />
                  </div>

                  <button className="bg-white rounded-[3.3px] flex justify-center items-center w-[26.4px] h-[14.52px] text-black font-extrabold text-[7.92px]">
                    PRO
                  </button>
                </div>
              </div>

              <span className="text-white text-[20px] font-medium flex  text-center leading-[32px] mt-3 ">
                Unlock your fantasy edge - subscribe now to access everything.
              </span>
            </div>
          </div>

          {/* Subscription Card */}
          <div
            className="flex-col px-5 pb-6 relative z-100"
            style={{
              background:
                "linear-gradient(180deg, rgba(5, 19, 44, 1) 0%, rgba(5, 19, 44, 0.5) 20%, rgba(5, 19, 44, 0.6) 50%, rgba(0, 0, 0, 0.8) 80%, rgba(0, 0, 0, 1) 100%)",
              top: "-40px",
            }}
          >
            <div
              className="w-full h-[119px] rounded-[10px] flex-col border-[2px] border-[#00E0FF] relative z-30"
              style={{
                background:
                  "linear-gradient(180deg, rgba(7, 27, 62, 1) 0%, rgba(4, 11, 31, 1) 100%)",
              }}
            >
              <div className="bg-[#00E0FF] w-fit px-4   h-[25px] flex items-center justify-center rounded-tl-[5px] rounded-br-[10px]">
                <span className="text-black text-[10px] font-medium">
                  Save 40%
                </span>
              </div>

              <div className="pl-4 pt-2">
                <span className="text-[16px] text-[#F3F3F3] font-medium">
                  Early Bird Special{" "}
                </span>
              </div>

              <div className="flex justify-end pr-2 mt-[-10px]">
                <span className="text-white/85 text-[14px] font-medium">
                  $6.67/mo
                </span>
              </div>

              <div className="flex items-center pl-4 gap-2">
                {/* Discounted Price */}
                <span className="text-[19.36px] font-semibold text-[#00B7FF] ">
                  {pricePreSeason}
                  <span className="text-[14.52px]">/yr</span>
                </span>
                {/* Original Price with strikethrough */}

                <span className="text-[12px] text-white/80 line-through font-semibold flex ">
                  ${129.99}
                </span>
              </div>
            </div>

            <div className="flex justify-center items-center mt-2">
              <span className="text-[10px] text-white/70 font-medium text-center">
                Start your 7-day free trial. Cancel anytime.
              </span>
            </div>
            <div className="mt-4">
              <div>
                <span className="text-[14.84px] font-semibold text-white ">
                  What do I get now?
                </span>
              </div>

              <div className="mt-1">
                {getNowFeatures.map((feature, index) => (
                  <div
                    key={index}
                    className={`flex gap-6 items-center mt-1 p-3 ${index !== getNowFeatures.length - 1 ? "border-b border-white/10" : ""}`}
                  >
                    <div>
                      <img
                        src={feature.icon}
                        alt={feature.title}
                        className="w-[22px] h-[22px]"
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <p className="text-white text-[13.99px] font-semibold">
                        {feature.title}
                      </p>
                      <p className="text-white/75 text-[11px] font-normal">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="mt-6 mb-4"
              style={{
                paddingBottom: `calc(env(safe-area-inset-bottom) + ${platform === "web" ? "80px" : " 30px"})`,
              }}
            >
              <div>
                <span className="text-[14.84px] font-semibold text-white ">
                  What’s coming?
                </span>
              </div>
              <div className="mt-1">
                {comingFeatures.map((feature, index) => (
                  <div
                    key={index}
                    className={`flex gap-6 items-center mt-1 p-3 ${index !== comingFeatures.length - 1 ? "border-b border-white/10" : ""}`}
                  >
                    <div>
                      <img
                        src={feature.icon}
                        alt={feature.title}
                        className="w-[22px] h-[22px]"
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <p className="text-white text-[13.99px] font-semibold">
                        {feature.title}
                      </p>
                      <p className="text-white/75 text-[11px] font-normal">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Fixed Claim Now Button with Animation */}
          <motion.div
            className="fixed bottom-0 left-0 right-0 z-50"
            style={{
              paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
            }}
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={
              showTrialButton
                ? { opacity: 1, y: 0, scale: 1 }
                : { opacity: 0, y: 50, scale: 0.9 }
            }
            transition={{
              duration: 0.6,
              ease: "easeOut",
              type: "spring",
              stiffness: 100,
            }}
          >
            <div className="px-[20px]">
              <motion.button
                className="w-full bg-[#00E0FF] py-3 rounded-[60px] flex justify-center items-center gap-[10px]"
                onClick={handleSubscribeClick}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.1 }}
              >
                <span className="text-[14px] text-[#000000] font-medium">
                  {"Start 7-Day Free Trial"}
                </span>
                <img src={subscribeRight} alt="subscribeRight" />
              </motion.button>
            </div>
          </motion.div>
        </Layout>
      </div>
    </div>
  );
};

export default EarlyBirdPaywall;
